import React, { useState } from "react";
import { Avatar, Popover } from "antd";
import { momentit } from "../../../utils";
import { ReactComponent as ViewIcon } from "../../../Icons/totalView.svg";
import { ReactComponent as HeartIcon } from "../../../Icons/heart.svg";
import { ReactComponent as HeartSelectedIcon } from "../../../Icons/heartSelect.svg";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as PdfWhiteIcon } from "../../../Icons/pdfWhiteIcon.svg";
import { markUnmarkFavourite } from "../../../API/api";
import { ReactComponent as InternalIcon } from "../../../Icons/internal.svg";
import { ReactComponent as DownloadIcon } from "../../../Icons/download.svg";
import Button2 from "../../Button2/Button2";
import AttachmentBox from "../../AttachmentBox/AttachmentBox";
import TooltipComp from "../../ToolTip/TooltipComp";
import { Home_PAGE_URL } from "../../../Router/routerUrl";
import { useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";

export default function QuestionBox({ question }) {
  const dispatch = useDispatch()
  const {recommendData, preservePreviousRecommendData} = bindActionCreators(Actions,dispatch)
  const searchState = useSelector((state) => state.search);
  const [isFavorite, setFavorite] = useState(question.favourite);
  const [hovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const onCLickFavorite = (key, flag) => {
    
    markUnmarkFavourite(key.questionUuid).then((res) => {
      if (res === undefined) return;
      setFavorite(flag);
    });
  };
  const infoContainer = {
    display: "flex",
    alignItems: "center",
    gap:"7px"
  };
  const dateInfoStyles = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom:'5px'
    // paddingLeft: "7px",

  };
  const textStyles = {
    fontSize: "24px",
    color: "#2A364A",
    lineHeight: "32px",
    fontWeight: "400",
    wordBreak: 'break-word',overflowWrap: 'break-word',
    cursor: hovered ? 'pointer' : 'default',
    textDecoration:hovered ? 'underline' : 'none'
  };
  const dateStyles = {
    fontSize: "13px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "300",
  };
  const confidenceStyles1 = {
    // width:'52px',
    height: "36px",
    border: "1px solid #F59B00",
    borderRadius: "6px",
    backgroundColor: "#F59B00",
    color: "#FFFFFF",
    lineHeight: "24px",
    fontSize: "14px",
    fontWeight: "500",
    padding: "6px 12px 6px 12px",
  };
  const confidenceStyles2 = {
    // width:'52px',
    height: "36px",
    border: "1px solid #00A3FF",
    borderRadius: "6px",
    backgroundColor: "#00A3FF",
    color: "#FFFFFF",
    lineHeight: "24px",
    fontSize: "14px",
    fontWeight: "500",
    padding: "6px 12px 6px 12px",
  };

  const generatingRelatedQ = (data) =>{
    if(data.text === undefined){
      data.text = data.questionText;
    }
    if(!data.reusableThreadQA){
      let payload ={
        data:{
          id:data.questionUuid,
        text:data.text
        }
      }
      preservePreviousRecommendData([])
      recommendData(payload);
      navigate(`${Home_PAGE_URL}recommend`);
    }else if(data.reusableThreadQA){
      if(data.status === 'accepted'){
        let payload ={
          data:{
            id:data.questionUuid,
          text:data.text
          }
        }
        preservePreviousRecommendData([])
        recommendData(payload);
        navigate(`${Home_PAGE_URL}recommend`);
      }
    }

  }

    const renderAttachemnt = (arr) => {
      return (
        <div>
            {arr.map((item, index) => (
              <div className="mb-1">
                {" "}
                <AttachmentBox key={index} attachment={item} />
              </div>
            ))}
        </div>
      );
    };

  return (
    <>
      <div style={infoContainer}>
        <div style={dateInfoStyles}>
          <div style={textStyles} onClick={()=>generatingRelatedQ(question)} onMouseEnter={()=>setIsHovered(true)} onMouseLeave={()=>setIsHovered(false)}>
          {question.text}
        </div>
      
        
          <div style={infoContainer}>
          {
                      question.seekerAttachments &&
                      question.seekerAttachments .length > 0 && (
                        <div style={{  }}>
                          <Popover title={renderAttachemnt(question.seekerAttachments )}>
                            {" "}
                            <Button2 onClickFunc={onCLickFavorite}>
                              <DownloadIcon />
                            </Button2>
                          </Popover>
                        </div>
                      )}
            {
              (isFavorite ? (
                <div style={{ marginRight: "6px", cursor: "pointer" }}>
                  <TooltipComp title={"Favorite question"}>
                  <HeartSelectedIcon
                    onClick={() => onCLickFavorite(question, false)}
                  /></TooltipComp>
                </div>
              ) : (
                <div style={{ marginRight: "6px", cursor: "pointer" }}>
                  <TooltipComp title={"Favorite question"}>
                  <HeartIcon onClick={() => onCLickFavorite(question, true)} /></TooltipComp>
                </div>
              ))}
               {question.isShowUpdateRequestWarning && <div><TooltipComp title={'Recommended request for update; this answer may not be up-to-date.'}><span><i class="fa fa-exclamation-circle" style={{fontSize:'22px', color:'#F59B00', marginRight:'5px', cursor:'pointer'}}></i></span></TooltipComp>
               </div>}
          </div>
        </div>
      </div>
    </>
  );
}
